import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

export interface CarrotAdBaseEntityParams {
  carrot_ad_format?: string;
  object_tracking_id?: string;
  placement_name: string;
  page_view_id?: string;
}

export class CarrotAdBaseEntity extends BaseEntityClass {
  ad_format: string;
  object_tracking_id: string;
  placement: string;
  page_view_id?: string;

  constructor(params: CarrotAdBaseEntityParams) {
    super();
    this.ad_format = params.carrot_ad_format;
    this.object_tracking_id = params.object_tracking_id;
    this.placement = params.placement_name;
    this.page_view_id = params.page_view_id;
  }
}
